module.exports = __webpack_public_path__ + "static/img/music-drop.a393fa0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music-drop.gif
// module id = 97
// module chunks = 180